var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _vm.loadPage
        ? _c(
            "div",
            { staticClass: "main-panel" },
            [
              _c("dashboard-content"),
              !_vm.noBanner && _vm.banners && _vm.banners.length
                ? _c(
                    "div",
                    { staticClass: "inner-noti" },
                    [
                      _c("notification-banner", {
                        attrs: {
                          notification: _vm.banners[0],
                          afterLogin: "true",
                        },
                        on: { userStatus: _vm.userStatus },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }